import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Login from "./views/Login.vue";
import ClassSchedule from "./views/ClassSchedule";
import OldCourse from "./views/OldCourse";
import ArchivedCourse from "./views/ArchivedCourse";
import CancleCourse from "./views/CancleCourse";
import CourseTitleAndOutline from "./views/CourseTitleAndOutline";

Vue.use(Router);

export default new Router({
  //mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "general_search",
      component: Home,
    },
    {
      path: "/Login",
      name: "login",
      component: Login,
    },
    {
      path: "/ClassSchedule",
      name: "class_schedule",
      component: ClassSchedule,
    },
    {
      path: "/OldCourse",
      name: "old_course",
      component: OldCourse,
    },
    {
      path: "/ArchivedCourse",
      name: "archived_course",
      component: ArchivedCourse,
    },
    {
      path: "/CancleCourse",
      name: "cancelled_course",
      component: CancleCourse,
    },
    {
      path: "/CourseTitleAndOutline",
      name: "archived_course_title_and_outline",
      component: CourseTitleAndOutline,
    },
  ],
});
